"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXTERNAL_PUBLISHERS = exports.COURSE_VISIBILITY = exports.COURSE_SUBSCRIPTION_TIERS = exports.COURSE_OBJECT_TYPES = void 0;
var COURSE_OBJECT_TYPES;
(function (COURSE_OBJECT_TYPES) {
    COURSE_OBJECT_TYPES["course"] = "course";
    COURSE_OBJECT_TYPES["section"] = "section";
    COURSE_OBJECT_TYPES["content"] = "content";
    COURSE_OBJECT_TYPES["module"] = "module";
})(COURSE_OBJECT_TYPES = exports.COURSE_OBJECT_TYPES || (exports.COURSE_OBJECT_TYPES = {}));
var COURSE_SUBSCRIPTION_TIERS;
(function (COURSE_SUBSCRIPTION_TIERS) {
    COURSE_SUBSCRIPTION_TIERS["free"] = "FREE";
    COURSE_SUBSCRIPTION_TIERS["premium"] = "PREMIUM";
})(COURSE_SUBSCRIPTION_TIERS = exports.COURSE_SUBSCRIPTION_TIERS || (exports.COURSE_SUBSCRIPTION_TIERS = {}));
var COURSE_VISIBILITY;
(function (COURSE_VISIBILITY) {
    COURSE_VISIBILITY["public"] = "PUBLIC";
    COURSE_VISIBILITY["hidden"] = "HIDDEN";
})(COURSE_VISIBILITY = exports.COURSE_VISIBILITY || (exports.COURSE_VISIBILITY = {}));
var EXTERNAL_PUBLISHERS;
(function (EXTERNAL_PUBLISHERS) {
    EXTERNAL_PUBLISHERS["somos"] = "SOMOS";
})(EXTERNAL_PUBLISHERS = exports.EXTERNAL_PUBLISHERS || (exports.EXTERNAL_PUBLISHERS = {}));
//# sourceMappingURL=Course.js.map